import type { Review } from "./types";

// Pure helper used by backend and unit tests
export function calculateAverageRating(reviews: Pick<Review, "rating">[]): number {
  if (!reviews.length) return 0;
  const sum = reviews.reduce((acc, r) => acc + r.rating, 0);
  return Math.round((sum / reviews.length) * 10) / 10;
}


